const fontSizes = {
  heading: '17pt',
  body: '12pt',
  secondary: '13px',
};

const transitions = {
  fadeInDown: '0.3s ease-in-out backwards',
  fadeIn: '0.3s ease-in-out backwards',
};

// eslint-disable-next-line
export const theme = {
  ...fontSizes,
  ...transitions,
  gray: 'rgb(142, 142, 147)',
  gray2: 'rgb(99, 99, 102)',
  gray3: 'rgb(72, 72, 74)',
  gray4: 'rgb(58, 58, 60)',
  gray5: 'rgb(44, 44, 46)',
  gray6: 'rgb(28, 28, 30)',
  text: 'rgba(255, 255, 255, .87)',
  textSecondary: 'rgba(255, 255, 255, .60)',
  textDisabled: 'rgba(255, 255, 255, .38)',
  blue: 'rgb(10, 132, 255)',
  blueHover: 'rgba(10, 132, 255, .88)',
  red: 'rgb(255, 69, 58)',
  redHover: 'rgba(255, 69, 58, .88)',
  green: 'rgb(48, 209, 88)',
  yellow: 'rgb(255, 159, 10)',
};
